import script from "./PagesNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesNav.vue?vue&type=script&setup=true&lang=js"

import "./PagesNav.vue?vue&type=style&index=0&id=3f777cff&lang=scss"

const __exports__ = script;

export default __exports__